import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  body {
    -webkit-font-smoothing: antialiased;
    /* width: 100vw;
    height: 100%; */
  }

  body , input, button, select, option {
    font-family: Muli, sans-serif;
    font-size: 16px;
  }

  div {
    user-select: none;
  }

  h1,h2,h3,h4,h5,h6,strong {
    font-weight: 500
  }

  button {
    cursor: pointer;
  }
`;
